export const esConfiguracionCss = (configuracion) => {
  const nombreTipo =
    configuracion?.opciones?.tipo?.nombre ??
    configuracion?.tipo?.nombre ??
    configuracion?.opciones?.tipo_nombre ??
    configuracion?.tipo_nombre;

  return nombreTipo?.toString().trim().toLowerCase() === "css";
};

export const obtenerCssDeConfiguracion = (configuracion) => {
  const datos = Array.isArray(configuracion?.datos?.data)
    ? configuracion.datos.data
    : configuracion?.datos;
  const datosArray = Array.isArray(datos) ? datos : [datos];
  const css =
    configuracion?.css ??
    configuracion?.CSS ??
    configuracion?.opciones?.css ??
    configuracion?.opciones?.CSS ??
    datosArray.find((dato) => dato?.css || dato?.CSS)?.css ??
    datosArray.find((dato) => dato?.css || dato?.CSS)?.CSS;
    console.log(datos)

  return typeof css === "string" ? css.trim() : "";
};

export const obtenerCssDeConfiguraciones = (configuraciones = []) =>
  configuraciones
    .filter(esConfiguracionCss)
    .map(obtenerCssDeConfiguracion)
    .filter(Boolean)
    .join("\n\n");

export const excluirConfiguracionesCss = (configuraciones = []) =>
  configuraciones.filter((configuracion) => !esConfiguracionCss(configuracion));
